import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './directives' // 全局注册自定义指令
import ElementUI from 'element-ui'
import '@/assets/css/element-variables.scss'
Vue.use(ElementUI)

import VideoPlayer from 'vue-video-player/src'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer)

// iconfont图标
// import '@/assets/css/iconfont.css'
// self css
import '@/assets/css/custom.scss'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
